<template>
  <div>
    <q-banner class="bg-primary text-white" inline-actions>
      <span v-if="!durationState">عملکرد فروش در باز زمانی اهداف فروش</span>
      <span v-if="durationState">بررسی عملکرد فروش در بازه زمانی خاص</span>
      <span v-if="startDate && endDate">
        <span> از تاریخ </span><span>{{startDate}}</span> <span>الی </span> <span>{{endDate}}</span>
      </span>
      <template v-slot:action>
        <q-chip v-if="salePrice && salePrice>0" :label="salePrice.toLocaleString()" color="green-10" text-color="white" />
      </template>
    </q-banner>
    <MyOrders @target-selected="targetSelected" :duration-state="durationState"/>
  </div>
</template>

<script>
import MyOrders from "@/components/dashboard/MyOrders";

export default {
  name: 'Home',
  components: {MyOrders},
  data() {
    return {
      slide: 1,
      startDate:undefined,
      endDate: undefined,
      salePrice: undefined,
      durationState: false
    }
  },
  methods:{
    targetSelected(args){
      this.startDate = args.startDate
      this.endDate = args.endDate
      this.salePrice = args.salePrice
    }
  },
  created() {
    this.durationState = this.$route.path==="/dashboard-duration"
  }
}
</script>
